import { connect } from 'react-redux';
import Chargeback from './chargeback';

export default connect()(Chargeback);
